import type { StudentRequest } from '@/types/student/student-request.type'
import { getRequestIconById } from '@/utils/get-request-type-icon-by-id'
import { getRequestStatusById } from '@/utils/get-status-by-id'
import { Card } from '../student-card'

interface StudentRequestCard {
  studentRequest: StudentRequest
}

export const StudentRequestCard = ({ studentRequest }: StudentRequestCard) => {
  const createdAt = studentRequest.createdAt
  const date = createdAt.toLocaleDateString('pt-BR')
  const hour = createdAt.getHours()
  const minutes = createdAt.getMinutes()
  const Icon = getRequestIconById(studentRequest.requestType.id)

  const status = getRequestStatusById(studentRequest.requestStatus.id)

  return (
    <Card
      variant="smCard"
      title={studentRequest.requestType.name}
      titleClassName="text-base"
      idSolicitacao={`#${studentRequest.protocol}`}
      dateSolicitacao={`${date.toString()} | ${hour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`}
      status={status?.student.name}
      statusColor={status?.student.color}
      className="border-ring"
      icon={Icon ? <Icon /> : null}
    />
  )
}
